import React from 'react';
import {
  withRouter,
  Link,
  RouteComponentProps,
} from 'react-router-dom';

export function AccountOrGameLink({ location }: Props) {
  if (
    location.pathname.startsWith('/account')
    || location.pathname.startsWith('/help')
  ) {
    return (
      <Link to="/">
        Back to game
      </Link>
    );
  }
  return (
    <Link to="/account">
      Account Settings
    </Link>
  );
}

type Props = RouteComponentProps;

export default withRouter(AccountOrGameLink);
